import { render, staticRenderFns } from "./LuckyWheel.vue?vue&type=template&id=790aa764&scoped=true&"
import script from "./LuckyWheel.vue?vue&type=script&lang=js&"
export * from "./LuckyWheel.vue?vue&type=script&lang=js&"
import style0 from "./LuckyWheel.vue?vue&type=style&index=0&id=790aa764&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790aa764",
  null
  
)

export default component.exports